import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    settingsHeaderText: {
      lineHeight: '1',
      fontSize: '40px',
      letterSpacing: 'normal',
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: '36px'
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '32px'
      },
      [theme.breakpoints.only('md')]: {
        fontSize: '36px'
      }
    },
    salesReportButton: {
      margin: '32px 0 0 20px',
      width: '145px'
    },
    fieldLabel: {
      fontSize: '16px',
      fontWeight: 700
    }
  })
);
